import { isFunction } from 'lodash-es'
import RiotControl from 'riotcontrol'
import logger from '../logger'

// /////////////////////
// global Model mixin //
// /////////////////////

export default {
  init() {
    const lname = this.root.tagName.toLowerCase()
    if (isFunction(this.on)) {
      this.on('before-mount', () => {
        logger(`Registering Order Observer on component :: ${lname}`, 'debug')()
        RiotControl.trigger('registerOrderObserver', this)
        logger(`Registering Application Observer on component :: ${lname}`, 'debug')()
        RiotControl.trigger('registerApplicationStateObserver', this)
        logger(`Registering Tests Observer on component :: ${lname}`, 'debug')()
        RiotControl.trigger('registerTestsObserver', this)
      })
      this.on('unmount', () => {
        logger(`Unregistering Order Observer on component :: ${lname}`, 'debug')()
        RiotControl.trigger('unregisterOrderObserver', this)
        logger(`Unregistering Application Observer on component :: ${lname}`, 'debug')()
        RiotControl.trigger('unregisterApplicationStateObserver', this)
        logger(`Unregistering Tests Observer on component :: ${lname}`, 'debug')()
        RiotControl.trigger('unregisterTestsStateObserver', this)
      })
    }
  },
}